// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-icon{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:100%}.account-icon svg{display:inline-block;font-size:inherit;height:1em;width:1em;vertical-align:-.125em;overflow:visible}.account-icon.bank svg{width:100%;height:100%;border-radius:100%;overflow:hidden}", ""]);
// Exports
module.exports = exports;
